export default __webpack_public_path__ + "static/media/customers_say.ff61ba85.png";